import React from "react"
import smile from '../../img/icon/smile.png';

export default function Smile() {
   return (
      <img src={smile} alt="" />
   )
}
